interface Route<T> {
  INTEGRATIONS: {
    F5Networks: {
      [key: string]: T
    },
  },
}

const F5NetworksRoutes: Route<{ index: string }> = {
  INTEGRATIONS: {
    F5Networks: {
      ACTIVITYAPI: {
        index: '/integrations/f5',
      },
    },
  },
};

const ApiRoutes: Route<string> = {
  INTEGRATIONS: {
    F5Networks: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/f5networks/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/f5networks/checkCredentials',

    },
  },
};

const DocsRoutes: Route<string> = {
  INTEGRATIONS: {
    F5Networks: {
      GRAYLOG_F5Networks_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_f5_ActivityLog_Input.html#graylog-f5-activitylog-input',
    },
  },
};

export default F5NetworksRoutes;

export { DocsRoutes, ApiRoutes };
